import {
  ActionPopover,
  ActionPopoverDivider,
  ActionPopoverItem,
  ActionPopoverMenuButton,
} from 'carbon-react/esm/components/action-popover';
import Box from 'carbon-react/esm/components/box';

interface DsnRowActionsProps {
  instanceId: string;
  isHighlighted: boolean;
  displayPdfImg: boolean;
  displayZipImg: boolean;
  handleHighlightRow: (id: string) => void;
  setHighlightedRow: (id: string) => void;
  handleDownload: (id: string, canDownload: boolean) => void;
  handleViewDeclaration: (id: string, canView: boolean) => void;
  downloadLoading: boolean;
  aerBilanLoading: boolean;
}

export const DsnRowActions = ({
  instanceId,
  isHighlighted,
  displayPdfImg,
  displayZipImg,
  handleHighlightRow,
  setHighlightedRow,
  handleDownload,
  handleViewDeclaration,
  downloadLoading,
  aerBilanLoading,
}: DsnRowActionsProps) => {
  if (!displayPdfImg && !displayZipImg) return null;

  return (
    <Box display="flex" alignItems="center" minHeight="48px">
      <ActionPopover
        placement="bottom"
        onOpen={() => handleHighlightRow(instanceId)}
        onClose={() => setHighlightedRow('')}
        renderButton={props => (
          <ActionPopoverMenuButton
            {...props}
            buttonType="tertiary"
            iconType="ellipsis_vertical"
            iconPosition="after"
            size="small"
            tabIndex={0}
            data-element="action-popover-menu-button"
            ariaAttributes={{
              'aria-label': 'More actions',
              'aria-controls': `popover-${instanceId}`,
              'aria-expanded': isHighlighted ? 'true' : 'false',
              'aria-haspopup': 'true',
            }}
          >
            Actions
          </ActionPopoverMenuButton>
        )}
      >
        {displayZipImg && (
          <ActionPopoverItem
            onClick={() => handleDownload(instanceId, displayZipImg)}
            icon="download"
            disabled={downloadLoading}
          >
            {downloadLoading ? 'Téléchargement...' : 'Télécharger'}
          </ActionPopoverItem>
        )}

        {displayZipImg && displayPdfImg && <ActionPopoverDivider />}

        {displayPdfImg && (
          <ActionPopoverItem
            onClick={() => handleViewDeclaration(instanceId, displayPdfImg)}
            icon="view"
            disabled={aerBilanLoading}
          >
            {aerBilanLoading ? 'Chargement...' : 'Voir le fichier'}
          </ActionPopoverItem>
        )}
      </ActionPopover>
    </Box>
  );
};
